export default __webpack_public_path__ + "static/media/LoadingAnimation.7ef59011.gif";